import { Box } from "@mui/material";
import {
  GlassImageModal,
  GlassImageModalContent,
  GlassCloseButton,
} from "../glassmorphism/GlassmorphismStyles";
import CloseIcon from '@mui/icons-material/Close';

interface PassedPRops {
    isImageModalOpen: boolean;
    handleCloseImageModal: () => void;
    base64SelectedImage: string | null;
}

const PreviewImageModal = (props: PassedPRops) => {
    return (
        <GlassImageModal
            open={props.isImageModalOpen}
            onClose={props.handleCloseImageModal}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <GlassImageModalContent>
                <GlassCloseButton
                    onClick={props.handleCloseImageModal}
                    aria-label="Close image preview"
                >
                    <CloseIcon />
                </GlassCloseButton>
                
                <img
                    src={props.base64SelectedImage || ''}
                    alt="Full-screen view"
                    style={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        borderRadius: '24px',
                        maxHeight: '85vh',
                        objectFit: 'contain',
                    }}
                />
            </GlassImageModalContent>
        </GlassImageModal>
    );
};

export default PreviewImageModal;